import { createPropertyEntityStrategy } from '../strategies/property';
import { useOnObjectsUpdated } from './useOnObjectsUpdated';
import { useMemo } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
export function useAutosaveStrategyMap() {
  const onObjectsUpdated = useOnObjectsUpdated();
  const httpClient = useHttpClient();
  return useMemo(() => ({
    PROPERTY: createPropertyEntityStrategy(httpClient, onObjectsUpdated)
  }), [onObjectsUpdated, httpClient]);
}